import {
    GET_PROFILE_BY_REFERRAL_CODE,
    GET_PROFILE_BY_REFERRAL_CODE_SUCCESS,
    GET_PROFILE_BY_REFERRAL_CODE_API_ERROR,
} from "./actionTypes"



export const findByReferralCode = params => {
    return {
        type: GET_PROFILE_BY_REFERRAL_CODE,
        payload: params,
    }
}

export const findByReferralCodeSuccess = data => {
    return {
        type: GET_PROFILE_BY_REFERRAL_CODE_SUCCESS,
        payload:  data 
    }
}

export const apifindByReferralCodeError = error => {
    return {
        type: GET_PROFILE_BY_REFERRAL_CODE_API_ERROR,
        payload: { error },
    }
}
